import {
  MediaExternalVideo,
  isMediaExternalVideo,
} from "types/CMS/KontentAI/content-types/external_video";
import {
  MediaAsset,
  isMediaAsset,
} from "types/CMS/KontentAI/content-types/asset";
import { media } from "types/CMS/Unum/media";
import { createResolver } from "./Factories/ResolverFactory";

export const assetResolver = createResolver({
  resolve: (asset: MediaAsset | MediaExternalVideo): media => {
    if (isMediaAsset(asset)) {
      return {
        type: "image",
        url: asset.elements.image.value[0].url,
        description: asset.elements.image.value[0].description ?? "",
      };
    }

    if (isMediaExternalVideo(asset)) {
      return {
        type: "video",
        url: asset.elements.url.value ?? "",
        description: "",
      };
    }

    return {
      type: undefined,
      url: "",
      description: "",
    };
  },
});

